/**
 * DocumentPreviewDialog
 * Shared dialog for previewing uploaded documents (images, PDFs).
 *
 * Usage:
 *   const docActions = useDocumentActions();
 *   <DocumentPreviewDialog {...docActions} />
 *
 * Props come directly from the useDocumentActions hook.
 */

import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from '@mui/material';

export default function DocumentPreviewDialog({
  previewOpen,
  previewUrl,
  previewType,
  previewDocId,
  closePreview,
  downloadDocument,
}) {
  const isImage = previewType?.startsWith('image/');

  return (
    <Dialog open={!!previewOpen} onClose={closePreview} maxWidth="md" fullWidth>
      <DialogTitle>Document Preview</DialogTitle>
      <DialogContent>
        {previewUrl && (
          <Box sx={{ width: '100%', minHeight: 500, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {isImage ? (
              <img
                src={previewUrl}
                alt="Document preview"
                style={{ maxWidth: '100%', maxHeight: '600px', objectFit: 'contain' }}
              />
            ) : (
              <object
                data={previewUrl}
                type={previewType || 'application/pdf'}
                style={{ width: '100%', height: '600px' }}
              >
                <Typography variant="body2" color="text.secondary">
                  Unable to preview this file type.{' '}
                  <Button size="small" onClick={() => downloadDocument(previewDocId)}>
                    Download instead
                  </Button>
                </Typography>
              </object>
            )}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={closePreview}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
